"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");

var uritemplate_1 = require("uritemplate");
/**
 * An RDF Metadata Extract Actor that extracts all Hydra controls from the metadata stream.
 */


var ActorRdfMetadataExtractHydraControls =
/*#__PURE__*/
function (_bus_rdf_metadata_ext) {
  _inherits(ActorRdfMetadataExtractHydraControls, _bus_rdf_metadata_ext);

  function ActorRdfMetadataExtractHydraControls(args) {
    var _this;

    _classCallCheck(this, ActorRdfMetadataExtractHydraControls);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataExtractHydraControls).call(this, args));
    _this.parsedUriTemplateCache = {};
    return _this;
  }

  _createClass(ActorRdfMetadataExtractHydraControls, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
    /**
     * Collect all Hydra page links from the given Hydra properties object.
     * @param pageUrl The page URL in which the Hydra properties are defined.
     * @param hydraProperties The collected Hydra properties.
     * @return The Hydra links
     */

  }, {
    key: "getLinks",
    value: function getLinks(pageUrl, hydraProperties) {
      return ActorRdfMetadataExtractHydraControls.LINK_TYPES.reduce(function (metadata, link) {
        // First check the correct hydra:next, then the deprecated hydra:nextPage
        var links = hydraProperties[link] || hydraProperties[link + 'Page'];
        var linkTargets = links && links[pageUrl];

        if (linkTargets && linkTargets.length > 0) {
          metadata[link] = linkTargets[0];
        }

        return metadata;
      }, {});
    }
    /**
     * Parse a URI template, or retrieve it from a cache.
     * @param {string} template A URI template string.
     * @return {} A parsed URI template object.
     */

  }, {
    key: "parseUriTemplateCached",
    value: function parseUriTemplateCached(template) {
      var cachedUriTemplate = this.parsedUriTemplateCache[template];

      if (cachedUriTemplate) {
        return cachedUriTemplate;
      }

      return this.parsedUriTemplateCache[template] = uritemplate_1.parse(template);
    }
    /**
     * Collect all search forms from the given Hydra properties object.
     * @param hydraProperties The collected Hydra properties.
     * @return The search forms.
     */

  }, {
    key: "getSearchForms",
    value: function getSearchForms(hydraProperties) {
      var _this2 = this;

      var searchFormData = hydraProperties.search;
      var searchForms = [];

      if (searchFormData) {
        for (var dataset in searchFormData) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            var _loop = function _loop() {
              var searchFormId = _step.value;
              var searchTemplates = (hydraProperties.template || {})[searchFormId] || []; // Parse the template

              if (searchTemplates.length !== 1) {
                throw new Error('Expected 1 hydra:template for ' + searchFormId);
              }

              var template = searchTemplates[0];

              var searchTemplate = _this2.parseUriTemplateCached(template); // Parse the template mappings


              var mappings = ((hydraProperties.mapping || {})[searchFormId] || []).reduce(function (acc, mapping) {
                var variable = ((hydraProperties.variable || {})[mapping] || [])[0];
                var property = ((hydraProperties.property || {})[mapping] || [])[0];

                if (!variable) {
                  throw new Error('Expected a hydra:variable for ' + mapping);
                }

                if (!property) {
                  throw new Error('Expected a hydra:property for ' + mapping);
                }

                acc[property] = variable;
                return acc;
              }, {}); // Gets the URL of the Triple Pattern Fragment with the given triple pattern

              var getUri = function getUri(entries) {
                return searchTemplate.expand(Object.keys(entries).reduce(function (variables, key) {
                  variables[mappings[key]] = entries[key];
                  return variables;
                }, {}));
              };

              searchForms.push({
                dataset: dataset,
                template: template,
                mappings: mappings,
                getUri: getUri
              });
            };

            for (var _iterator = searchFormData[dataset][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }

      return {
        values: searchForms
      };
    }
    /**
     * Collect all hydra properties from a given metadata stream
     * in a nice convenient nested hash (property / subject / objects).
     * @param {RDF.Stream} metadata
     * @return The collected Hydra properties.
     */

  }, {
    key: "getHydraProperties",
    value: function getHydraProperties(metadata) {
      return new Promise(function (resolve, reject) {
        metadata.on('error', reject); // Collect all hydra properties in a nice convenient nested hash (property / subject / objects).

        var hydraProperties = {};
        metadata.on('data', function (quad) {
          if (quad.predicate.value.startsWith(ActorRdfMetadataExtractHydraControls.HYDRA)) {
            var property = quad.predicate.value.substr(ActorRdfMetadataExtractHydraControls.HYDRA.length);
            var subjectProperties = hydraProperties[property] || (hydraProperties[property] = {});
            var objects = subjectProperties[quad.subject.value] || (subjectProperties[quad.subject.value] = []);
            objects.push(quad.object.value);
          }
        });
        metadata.on('end', function () {
          return resolve(hydraProperties);
        });
      });
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var metadata, hydraProperties;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                metadata = {};
                _context2.next = 3;
                return this.getHydraProperties(action.metadata);

              case 3:
                hydraProperties = _context2.sent;

                require('lodash.assign')(metadata, this.getLinks(action.url, hydraProperties));

                metadata.searchForms = this.getSearchForms(hydraProperties);
                return _context2.abrupt("return", {
                  metadata: metadata
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorRdfMetadataExtractHydraControls;
}(bus_rdf_metadata_extract_1.ActorRdfMetadataExtract);

ActorRdfMetadataExtractHydraControls.HYDRA = 'http://www.w3.org/ns/hydra/core#';
ActorRdfMetadataExtractHydraControls.LINK_TYPES = ['first', 'next', 'previous', 'last'];
exports.ActorRdfMetadataExtractHydraControls = ActorRdfMetadataExtractHydraControls;